import React from "react";
import { motion } from "framer-motion";
import {
  FaMoneyCheckAlt,
  FaUndoAlt,
  FaExclamationTriangle,
  FaShieldAlt,
  FaEnvelopeOpenText,
} from "react-icons/fa";

const RefundAndCancellation = () => {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-pink-100 via-white to-purple-100 flex justify-center items-center p-6"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1522204523234-872a3e5e7b04?auto=format&fit=crop&w=1470&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="bg-white bg-opacity-90 backdrop-blur-xl rounded-3xl shadow-2xl max-w-4xl w-full p-10 overflow-y-auto"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="flex justify-center mb-6">
          <FaMoneyCheckAlt className="text-5xl text-pink-600 animate-bounce" />
        </div>
        <h1 className="text-4xl font-bold text-center text-pink-700 mb-6">
          Refund & Cancellation Policy
        </h1>

        <p className="mb-4 text-gray-700 text-center">
          At <span className="font-semibold">Vicademics</span>, we aim to
          provide a seamless and fair experience for all our learners and
          instructors.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-pink-600">
          <FaUndoAlt /> Refund Policy
        </motion.h2>
        <p className="mb-4 text-gray-700">
          All course purchases are generally non-refundable. Refunds will only
          be considered in exceptional cases such as duplicate transactions or
          technical issues preventing course access, and must be requested
          within 7 days of purchase.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-pink-600">
          <FaExclamationTriangle /> Non-Refundable Situations
        </motion.h2>
        <p className="mb-4 text-gray-700">
          Refunds will not be provided for reasons including but not limited to:
        </p>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>Change of mind after purchase.</li>
          <li>
            Failure to complete the course within the one-year validity period.
          </li>
          <li>Unsatisfactory content unless it violates our policies.</li>
        </ul>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-pink-600">
          <FaShieldAlt /> Cancellation Policy
        </motion.h2>
        <p className="mb-4 text-gray-700">
          You may cancel your subscription or enrollment at any time; however,
          no refunds will be issued for remaining access time after
          cancellation. Access to purchased courses will continue until the end
          of the one-year validity period.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-pink-600">
          <FaEnvelopeOpenText /> Requesting a Refund
        </motion.h2>
        <p className="mb-6 text-gray-700">
          To request a refund under exceptional cases, please email us at{" "}
          <a
            href="mailto:support@Vicademics.com"
            className="text-pink-600 underline"
          >
            support@Vicademics.com
          </a>{" "}
          with your purchase details and a clear explanation. We will review
          your request and respond within 5-7 business days.
        </p>

        <p className="text-center text-gray-500 text-sm">
          Last updated: June 2025
        </p>
      </motion.div>
    </div>
  );
};

export default RefundAndCancellation;
